import { LoadingContainer } from 'peach/components'

import DynamicForm from 'core/components/lib/DynamicForm/DynamicForm'
import { Page, PageHeader } from 'core/components'
import { installmentLoanTypeSchema } from 'core/utils/generated/formSchemas'
import {
  InstallmentConfigurationData,
  useCompanyLoanConfigurationsAdd,
} from 'core/types'
import { defaultInstallmentLoanType } from './utils/defaultLoanType'
import { useHistory, useParams } from 'peach/router'

const CreateInstallmentLoanType = () => {
  const history = useHistory()
  const { companyId } = useParams<{ companyId?: string }>()

  const { mutateAsync: createLoanType } = useCompanyLoanConfigurationsAdd({
    companyId,
  })
  const onSubmit = async (
    data: InstallmentConfigurationData | Partial<InstallmentConfigurationData>,
  ) => {
    const res = await createLoanType(data as InstallmentConfigurationData)

    const createdId = (res.data as InstallmentConfigurationData)?.id
    if (createdId) {
      history.push(`/companies/${companyId}/loan-types/${createdId}`)
    }
  }

  return (
    <LoadingContainer>
      <Page variant='full'>
        <PageHeader title='Create Installment Loan Type' />
        <DynamicForm
          data={defaultInstallmentLoanType}
          fieldEditMode='all'
          fieldOrder={['type', 'name', 'assetDisplayName', 'assetType']}
          omitFields={['id', 'createdAt', 'deletedAt', 'updatedAt']}
          onSubmit={onSubmit}
          schema={installmentLoanTypeSchema}
          submitText='Create Installment Loan Type'
        />
      </Page>
    </LoadingContainer>
  )
}

export default CreateInstallmentLoanType
